import Vue from 'vue';
import axios from 'axios';
import Constants from '@/plugins/constants';
const apiClient = axios.create({
  baseURL: Constants.MAINURL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});
var options = {
  persist: true,
};
Vue.use(options);
apiClient.interceptors.request.use(
  function (config) {
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

const state = {
  error400: false,
  error: '',
  successFlag: false,
  token: '',
  allRecentCalls: [],
  recentCallsResponse: {},
  errorStatus: null,
  callLocation: null,
  file: null,
};
const getters = {
  getApiLoad_116: (state) => {
    return state.successFlag;
  },
};
const mutations = {
  set_error400(state, error) {
    state.error400 = error;
  },
  SET_Status(state, status) {
    state.successFlag = status;
  },
  SET_Error(state, error) {
    state.error = error;
  },
  SET_errorStatus(state, error) {
    state.errorStatus = error;
  },
  SET_AllRecentCalls(state, calls) {
    state.allRecentCalls = calls;
  },
  SET_RecentCallsRes(state, recentCallsRes) {
    state.recentCallsResponse = recentCallsRes;
  },
  SET_CallLocation(state, data) {
    state.callLocation = data;
  },
  SET_File(state, data) {
    state.file = data;
  },
};
const actions = {
  errorCall({ commit }, temperror) {
    var error = temperror;
    if (error) {
      if (error.response) {
        if (error.response.status) {
          if (error.response.status == 401) {
            commit('SET_errorStatus', true);
            commit('set_error400', false);
          } else if (error.response.status == 400) {
            commit('SET_errorStatus', false);
            commit('set_error400', true);
          } else {
            commit('SET_errorStatus', false);
            commit('set_error400', false);
          }
        }
        if (error.response.data) {
          commit('SET_Error', error.response.data.message);
        } else {
          commit('SET_Error', 'عدم ارتباط با سرور');
        }
      } else {
        commit('SET_errorStatus', false);
        commit('set_error400', false);
        commit('SET_Error', 'خطا در برقراری ارتباط با سرور');
      }
      commit('SET_Status', false);
    } else {
      commit('SET_Error', 'خطا امنیتی');
    }
  },
  getRecentCallsList({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Calls/ByUserPagination', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
      })
      .then((response) => {
        commit('SET_RecentCallsRes', response.data);
        commit('SET_Status', true);
      })
      .catch((error) => {
        dispatch('errorCall', error);
      });
  },
  getCallVoiceFile({ commit, dispatch, rootState }, params) {
    return apiClient
      .get('/Calls/Listen', {
        params,
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        responseType: 'blob',
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_File', response.data);
      })
      .catch((error) => {
        dispatch('errorCall', error);
      });
  },
  getCallFileMission({ commit, dispatch, rootState }, id) {
    return apiClient
      .get('/Calls/ListenMission?id=' + id, {
        headers: { 'X-CSRF-Token': rootState.loginModule.csrf },
        responseType: 'blob',
      })
      .then((response) => {
        commit('SET_Status', true);
        commit('SET_File', response.data);
      })
      .catch((error) => {
        dispatch('errorCall', error);
      });
  },
};
export default {
  mutations,
  getters,
  state,
  actions,
};
